import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import compose from 'recompose/compose'
import classNames from 'classnames'
import {closeSnackbar} from '../../reducers/snackbar'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'
import WarningIcon from '@material-ui/icons/Warning'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {amber, green} from '@material-ui/core/colors'
import {makeStyles} from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
    error: {
        backgroundColor: theme.palette.error.dark
    },
    info: {
        backgroundColor: theme.palette.primary.main,
    },
    success: {
        backgroundColor: green[600],
    },
    warning: {
        backgroundColor: amber[700],
    },
}));

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
}


let SnackbarContentWrapper = ({className, message, onClose, variant = 'default', ...other}) => {
    const classes = useStyles();
    const Icon = variantIcon[variant];
    if (!other.action) {
        other.action = [
            <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
                <CloseIcon className={classes.icon}/>
            </IconButton>,
        ]
    }
    return (
        <SnackbarContent
            className={classNames(classes[variant], className)}
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" className={classes.message}>
                    {Icon && <Icon className={classNames(classes.icon, classes.iconVariant)}/>}
                    {message}
                </span>
            }
            {...other}
        />
    );
};

SnackbarContentWrapper.propTypes = {
    className: PropTypes.string,
    message: PropTypes.string,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(['error', 'info', 'success', 'warning', 'default']),
};


let SnackbarToast = ({open, text, action, props, closeSnackbar}) => {

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        closeSnackbar()
    };

    return (
        <Snackbar
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            open={open}
            autoHideDuration={props.duration || 6000}
            onClose={handleClose}

        >
            <SnackbarContentWrapper
                onClose={handleClose}
                message={text}
                action={action}
                {...props}
            />
        </Snackbar>
    )
};

SnackbarToast.propTypes = {
    // connected
    open: PropTypes.bool.isRequired,
    text: PropTypes.string,
    action: PropTypes.any,
    props: PropTypes.object,
    closeSnackbar: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
    return {
        open: state.snackbar.open,
        text: state.snackbar.text,
        action: state.snackbar.action,
        props: state.snackbar.props,
    }
}

export {Snackbar}
export default compose(
    connect(mapStateToProps, {closeSnackbar})
)(SnackbarToast)
